import { createContext, useContext } from "react";
import { GridRowsReturn } from "./useGridRows";

export const GridRowsContext = createContext<GridRowsReturn | null>(null);

const useGridRowsContext = () => {
  const context = useContext(GridRowsContext);
  if (!context) {
    throw new Error("useGridRowsContext must be used within GridRowsProvider");
  }
  return context;
};

export default useGridRowsContext;
